import React, { useState, useContext, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";

import AddIcon from "@mui/icons-material/Add";

import Title from "../../../../components/title";
import Table from "../../../../components/table";

import { takePermission } from "../../../../funcs";

import { ModalController } from "../../../homeUI/_index";
import { PRIOR_LIST } from "../../../../apis/_index";
import { toast } from "react-toastify";
import axios from "axios";

import {
  ONLOAD_PRIORLIST,
  ONLOAD_DIFFICULT_LIST,
} from "../../../../redux/reducers/settingReducer/_index";
import { DIFFICULT_LEVEL } from "../../../../apis/_index";
import { unsignedToAccented } from "../../../../helpers/handleHelper";
import ServiceUtils from "../../../../utils/services";

const DifficultRateUI = () => {
  const settingData = useSelector((state: any) => state.settingReducer);

  const [dificults, setDificult] = useState(
    (settingData || {}).dificultList || []
  );

  const context = useContext(ModalController);
  const menu = takePermission(13);

  const dispatch = useDispatch();
  const shouldLog = useRef(true);

  const _onClickCreatePrior = () => {
    context.setFuncs("createDificult");
    context.handleOpen();
  };

  useEffect(() => {
    if (shouldLog.current) {
      shouldLog.current = false;

      const takeData = async () => {
        try {
          await ServiceUtils.getV2(DIFFICULT_LEVEL, {
            headers: {
              Accept: "text/plain",
            },
          }).then((res: any) => {
            if (res.status === 200) {
              dispatch(ONLOAD_DIFFICULT_LIST(res.data.Data));
            } else {
              toast.error(res.data.Message);
            }
          });
        } catch (error: any) {
          toast.error(
            "Không kết nối được máy chủ, vui lòng kiểm tra lại đường truyền hoặc đăng nhập lại phần mềm!"
          );
        }
      };

      takeData();
    }
  });

  useEffect(() => {
    if (dificults.length <= 0) {
      setDificult(settingData.dificultList || []);
    }
  }, [settingData.dificultList]);

  const onKeyUpSearch = (e: any) => {
    const value = e.target.value;

    console.log(dificults);

    if (!value) {
      dispatch(ONLOAD_DIFFICULT_LIST(dificults));
    } else {
      const valueFilter = unsignedToAccented(value.trim().toLowerCase());

      const dificultFilters = dificults.filter((p: any) => {
        const difficultLevelName = unsignedToAccented(
          (p.DifficultLevelName || "").trim().toLowerCase()
        );

        return (
          difficultLevelName.includes(valueFilter) ||
          difficultLevelName.startsWith(valueFilter) ||
          difficultLevelName.endsWith(valueFilter) ||
          difficultLevelName.indexOf(valueFilter) > -1 ||
          difficultLevelName.lastIndexOf(valueFilter) > -1
        );
      });

      dispatch(ONLOAD_DIFFICULT_LIST(dificultFilters));
    }
  };

  return (
    <div className="h-full w-full flex flex-col">
      <Title />

      <div className="flex flex-col w-full h-[calc(100%-3rem)] lg:px-5 p-3 space-y-3">
        <div className="w-full h-[2rem] flex justify-between items-center">
          <input
            className="w-max h-[2.4rem] rounded-[4px] pl-2 pr-2 border-[1px] border-gray-400"
            placeholder="Tìm kiếm độ khó"
            onKeyUp={onKeyUpSearch}
          />

          <button
            className={`
              p-2 bg-green-500 rounded-md text-white
              hover:bg-green-400 items-center
              ${menu.PerInsert === true ? "flex" : "hidden"}
            `}
            onClick={_onClickCreatePrior}
          >
            <AddIcon fontSize="small" />
            <p className="hidden lg:flex">Thêm mới</p>
          </button>
        </div>

        <Table />
      </div>
    </div>
  );
};

export default DifficultRateUI;
